export default "__VITE_ASSET__D6nQoSS9__"